<template>
  <section id="about" class="py-16 md:py-24">
    <div class="max-w-7xl mx-auto px-4 md:px-8">
      <div class="text-center max-w-3xl mx-auto mb-10 md:mb-14">
        <h2 class="text-3xl md:text-4xl font-bold mb-2">
          {{ $t('about.title') }}
        </h2>
        <p class="text-lg font-medium text-text-secondary mb-3">
          {{ $t('about.subtitle') }}
        </p>
        <p class="text-text-secondary leading-relaxed">
          {{ $t('about.description') }}
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div
          v-for="(item, index) in values"
          :key="item.icon"
          class="card-brutal p-6 h-full"
        >
          <div
            class="inline-flex items-center justify-center w-10 h-10 rounded-md border-2 border-border mb-4"
            :class="item.iconBg"
          >
            <!-- Rebel / Challenge -->
            <svg
              v-if="item.icon === 'rebel'"
              class="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>

            <!-- Target / Extreme -->
            <svg
              v-else-if="item.icon === 'target'"
              class="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10" />
              <circle cx="12" cy="12" r="6" />
              <circle cx="12" cy="12" r="2" />
            </svg>

            <!-- Share / Confidence -->
            <svg
              v-else-if="item.icon === 'share'"
              class="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M18 8a3 3 0 1 0-3.5-2.6L8.5 9.2A3 3 0 1 0 8.5 14.8l6 3.8a3 3 0 1 0 .8-1.3l-6-3.8a3 3 0 0 0 0-1.4l6-3.8A3 3 0 0 0 18 8z" />
            </svg>
          </div>
          <h3 class="text-lg font-bold mb-1.5">{{ $t(`about.items[${index}].title`) }}</h3>
          <p class="text-text-secondary text-sm leading-relaxed">{{ $t(`about.items[${index}].description`) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const values = [
  { iconBg: 'bg-primary', icon: 'rebel' },
  { iconBg: 'bg-accent', icon: 'target' },
  { iconBg: 'bg-brutal-lime', icon: 'share' },
];
</script>
